export default {
      id: "Icon--locationGenericMarker-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--locationGenericMarker",
      toString: function () {
        return this.url;
      }
    }